<template>

    <div>

        <Select v-model="client" :options="clients" opt-id="id" opt-text="nome" @input="changeSelect">
        </Select>

    </div>


</template>
<script>

    import Select from './Select'
    import Facade from '../../facade/facade'

    const facade = new Facade();

    export default {
        components: {Select},
        props: ['value'],
        data() {
            return {
                clients: [],
                client: null
            }
        },
        async beforeCreate() {
            const clients = await facade.listClient({});
            this.clients = clients.data.data.rows
        },
        watch: {
            value(newVal) {
                this.client = newVal
            }
        },
        methods: {
            changeSelect(newVal) {
                this.$emit('input', newVal)
            },
        }
    }


</script>


// WEBPACK FOOTER //
// SelectClient.vue?69af9539